module.exports = "https://cdn.realtymogul.com/static/media/Eli_M.7fdc392c.jpg";